import React, { useEffect, useContext } from 'react'
import { Link, useHistory, useLocation } from "react-router-dom"
import { SiteTemplateLocBlue, SiteTemplateLocWhite, UsersBlue, UsersWhite, NotificationSelected, NotificationUnSelected, AlertPrePostSelected, AlertPrePostDefault, SoundSettingSelected, SoundSettingDefault, EscalationSelected, EscalationUnSelected, CentralizeRecording, CentralizeRecordingSelected, dashboard, DashboardUnselected, ImportSidebarIcon, ImportSidebarIconWhite, Interface, InterfaceWhite, Onvif, OnvifWhite} from '../../assets/images';
import { VERSION, IS_SITE_MANAGEMENT_TAB_HIDDEN, IS_ALERT_TEMPLATE_TAB_HIDDEN, IS_USERS_TAB_HIDDEN, IS_NOTIFICATION_SETTING_TAB_HIDDEN, IS_PREPOSTSETTING_TAB_HIDDEN, IS_EMAILSETTING_TAB_HIDDEN, IS_SOUNDSETTING_TAB_HIDDEN, IS_ESCALATIONTEMPLATE_TAB_HIDDEN, IS_CENTRALIZERECORDINGSYSTEM_TAB_HIDDEN, IS_INTERFACE_TAB_HIDDEN, IS_CUSTOMER_TAB_HIDDEN, IS_ONVIF_TAB_HIDDEN } from '../../config';
import { DrawerContext } from "../../Context/DrawerContext";
import alertSelected from '../../assets/images/sidebar-logo/alertSelected.svg'
import alertUnselected from '../../assets/images/sidebar-logo/alertUnselected.svg'
import reportSelected from '../../assets/images/sidebar-logo/reports-selected.svg'
import reportUnselected from '../../assets/images/sidebar-logo/reports-unselected.svg'
import { ABOUTTERMS, CONFIG_ALERTTEMPLATE, CONFIG_CENTRALIZERECORDINGSYSTEM, CONFIG_CONTACT_MAPPINGS, CONFIG_CUSTOMER, 
    CONFIG_DASHBOARDSETTING, CONFIG_DATACCESSGROUP, CONFIG_DEVICES, CONFIG_EMERGENCY_CONTACT, CONFIG_ESCALATIONTEMPLATE, 
    CONFIG_EXPORT, CONFIG_FR, CONFIG_IMPORT, CONFIG_INTERFACE, CONFIG_MANAGESITEGROUPS, CONFIG_NOTIFICATION, CONFIG_PREPOST, 
    CONFIG_REPORT, CONFIG_SITE, CONFIG_SOUND, CONFIG_USER, CONFIG_USERROLE, CONFIG_WORKFLOW, CONFIG_ZONE, CONFIGURATION, CONFIG_DISCOVER_DEVICES, 
    CONFIG_RECORDING_CONFIGURATION,
    CONFIG_PREDISCOVER_DEVICES,
    CONFIG_VIEWDISCOVER_DEVICES,
    CONFIG_AUTODISCOVER_DEVICES} from '../../navigation/CONSTANTS';

let tempSiteObj = {
    "SiteID": 0,
    "SiteName": '',
    "BranchID": '',
    "SiteAddress": '',
    "clientID": 0,
    "AddCustomerName": '',
    "CountryName": 0,
    "StateName": 0,
    "CityName": '',
    "SiteRegionName": '',
    "SitePincode": '',
    "SiteArea": '',
    "SiteModeID":0
}
export default function ConfigSideBar({ list, onNavigate, setIsItemClick, selectedSubMenu,
    setSelectedSubMenu, onMoveNext, selectedMainMenu, selectedMenu, setSelectedMenu, setSelectedSite, setSelectedInterface, setAlertTemplateObj, setIsAlertTemplateEdit, setIsAlertTempFormEnabled, setIsEmptyFormAlert,
    setDeviceTemplateList, setDevTemClicked, setSelTempDevice, setDisplayButtons, isDarkTheme, setActivityLogShow, setInterfaceDataList, setPageState,
}) {
    const { collapsed, setCollapsed } = useContext(DrawerContext);
    
    let history = useHistory();
    const location = useLocation()

    useEffect(() => {
        if (selectedSubMenu === 'Site Configuration' || selectedSubMenu === "Manage Devices" || selectedSubMenu === "Manage Site Groups") {
            setIsItemClick(false);
        }
        if (selectedSubMenu === 'Add Alert Template' || selectedSubMenu === "Manage Workflow") {
            setIsItemClick(false);
        }
        if (selectedSubMenu === 'Add User' || selectedSubMenu === "FR Assignment" || selectedSubMenu === "Data Access Group") {
            setIsItemClick(false);
        }
    },)

    useEffect(() => {
        if (location.pathname == CONFIGURATION) {
            setSelectedMenu('Site Management'); 
            setSelectedSubMenu('Site Configuration'); 
            onMoveNext('siteTemplate'); 
            setSelectedSite(tempSiteObj);
        } else if (location.pathname == CONFIG_MANAGESITEGROUPS) {
            setSelectedMenu('Site Management'); 
            setSelectedSubMenu('Manage Site Groups');
            onMoveNext('siteTemplate');
        } else if (location.pathname == CONFIG_ALERTTEMPLATE) {
            setSelectedMenu('Alert Template'); 
            onMoveNext('alertTemplate'); 
            setSelectedSubMenu('Add Alert Template');
            let tObj = {
                templateId: "",
                templateName: "",
                templateClientId: "0",
                templateSiteId: [],
                templateDeviceTypeId: "0",
                templateDeviceSubTypeId: "0",
                templateDevice: [],
                templateAlertType: "0",
                scheduleType: "NA",
                schedulerObj: {},
                tempSelectedSites: [],
                tempSelectedDevices: [],
            }
            setAlertTemplateObj(tObj);
            setIsAlertTemplateEdit(true)
            setIsAlertTempFormEnabled(true);
            setIsEmptyFormAlert(true);
            setDeviceTemplateList([]);
            setDevTemClicked(false);
            setSelTempDevice(null);
            setDisplayButtons(true);
            setActivityLogShow(false);
        } else if (location.pathname == CONFIG_WORKFLOW) {
            setSelectedMenu('Alert Template'); 
            setSelectedSubMenu('Manage Workflow');
            onMoveNext('alertTemplate')
        } else if (location.pathname == CONFIG_USER) {
            setSelectedMenu('Users'); 
            setSelectedSubMenu('Add User');
            onMoveNext('users'); 
        } else if (location.pathname == CONFIG_USERROLE) {
            setSelectedMenu('Users'); 
            setSelectedSubMenu('User Roles');
            onMoveNext('users'); 
        } else if (location.pathname == CONFIG_FR) {
            setSelectedMenu('Users');
            setSelectedSubMenu('FR Assignment');
            onMoveNext('users');
        } else if (location.pathname == CONFIG_DATACCESSGROUP) {
            setSelectedMenu('Users');
            setSelectedSubMenu('Data Access Group');
            onMoveNext('users');
        } else if(location.pathname == CONFIG_SOUND){
            setSelectedMenu('Sound Setting');
            onMoveNext('soundSetting');
        } else if(location.pathname == CONFIG_ESCALATIONTEMPLATE) {
            setSelectedMenu('Escalation Template');
            onMoveNext('escalationTemplate');
        } else if (location.pathname == CONFIG_PREPOST) {
            setSelectedMenu('Alert Pre Post Setting');
            onMoveNext('prePostSetting');
        } else if (location.pathname == CONFIG_NOTIFICATION) {
            setSelectedMenu('Notification Setting');
            onMoveNext('notification');
        } 
        else if(location.pathname == CONFIG_CENTRALIZERECORDINGSYSTEM) {
            setSelectedMenu('Video Backup')
            onMoveNext('centralizerecordingsystem')
        } 
        else if(location.pathname == CONFIG_IMPORT) {
            setSelectedMenu('Import')
            onMoveNext('Import')
        } 
        else if(location.pathname == CONFIG_EXPORT) {
            setSelectedMenu('Export')
            onMoveNext('Export')
        } 
        else if(location.pathname == CONFIG_REPORT) {
            setSelectedMenu('Report Template')
            onMoveNext('ReportTemplate')
        }
        else if(location.pathname == CONFIG_DASHBOARDSETTING) {
            setSelectedMenu('Dashboard Setting')
            onMoveNext('DashboardSetting')
        }  
        else if(location.pathname == CONFIG_SITE) {
            setSelectedMenu('Sites'); 
            setSelectedSubMenu('Sites');
            onMoveNext('sites'); 
        }  
        else if(location.pathname == CONFIG_ZONE) {
            setSelectedMenu('Sites');
            setSelectedSubMenu('Zones');
            onMoveNext('Zones');
        }  
        else if(location.pathname == CONFIG_EMERGENCY_CONTACT) {
            setSelectedMenu('Sites');
            setSelectedSubMenu('Emergency Contact');
            onMoveNext('EmergencyContact');
        } 
         else if(location.pathname == CONFIG_CONTACT_MAPPINGS) {
            setSelectedMenu('Sites');
            setSelectedSubMenu('Emergency Contact Mapping');
            onMoveNext('EmergencyContactMapping');
        } 
        else if (location.pathname == CONFIG_INTERFACE) {
            setSelectedMenu('Interface'); 
            setSelectedSubMenu('Interface');
            onMoveNext('Interface'); 
        }
         else if (location.pathname == CONFIG_DEVICES) {
            setSelectedMenu('Interface'); 
            setSelectedSubMenu('Devices');
            onMoveNext('Devices'); 
        }
        else if (location.pathname == CONFIG_CUSTOMER) {
            setSelectedMenu('Customers');
            onMoveNext('customer');
        }
        else if (location.pathname == CONFIG_DISCOVER_DEVICES) {
            setSelectedMenu('Onvif'); 
            setSelectedSubMenu('Discover Devices');
            onMoveNext('DiscoverDevices'); 
        } 
        else if (location.pathname == CONFIG_VIEWDISCOVER_DEVICES) {
            setSelectedMenu('Onvif'); 
            setSelectedSubMenu('View Discover Devices');
            onMoveNext('ViewDiscoverDevices'); 
        } 
        else if (location.pathname == CONFIG_PREDISCOVER_DEVICES) {
            setSelectedMenu('Onvif'); 
            setSelectedSubMenu('Pre Onboard Devices');
            onMoveNext('PreOnboardDevices'); 
        } 
         else if (location.pathname == CONFIG_AUTODISCOVER_DEVICES) {
            setSelectedMenu('Onvif'); 
            setSelectedSubMenu('Auto Discover Devices');
            onMoveNext('AutoDiscoverDevices'); 
        } 
        else if (location.pathname == CONFIG_RECORDING_CONFIGURATION) {
            setSelectedMenu('Onvif'); 
            setSelectedSubMenu('Recording Configuration');
            onMoveNext('RecordingConfiguration'); 
        }
    }, [location.pathname]);

    useEffect(() => {
        if (selectedMainMenu) {
            setSelectedMenu(selectedMainMenu)
        }
    }, [selectedMainMenu])

    return (
        <div>
            <div className={collapsed ? '' : 'sidebar-minimized'}>
                <div className="sidebar left updatedSidebar">
                    <nav className="sidebar-nav">
                        <div className="menu-list">
                            <ul id="menu-content" className="navList borderLineList">
                                <li
                                    style={{ display: IS_SITE_MANAGEMENT_TAB_HIDDEN ? 'none' : 'none' }}
                                    onClick={() => {
                                        if (selectedMenu == 'Site Management' && selectedSubMenu == 'Site Configuration') {
                                            return;
                                        }
                                        setSelectedMenu('Site Management'); onMoveNext('siteTemplate'); setSelectedSubMenu('Site Configuration'); setSelectedSite(tempSiteObj); history.push(CONFIGURATION)
                                        setInterfaceDataList(null)
                                    }}
                                    className={selectedMenu == "Site Management" ? "nav-item nav-dropdown open" : 'nav-item nav-dropdown'}>
                                    <a className='nav-link'>
                                        {
                                            !isDarkTheme ?
                                                <>
                                                    <img src={selectedMenu == "Site Management" ? SiteTemplateLocWhite : SiteTemplateLocWhite} alt="Logo" height={17} width={17} />
                                                    <span className={`pl-3 ${selectedMenu == "Site Management" ? "nav-label" : "nav-label"}`}>Site Management</span>
                                                </>
                                                :
                                                <>
                                                    <img className='onHoverImage' src={selectedMenu == "Site Management" ? SiteTemplateLocWhite : SiteTemplateLocBlue} alt="Logo" height={17} width={17} />
                                                    <img src={SiteTemplateLocWhite} className='onHoverActiveImage' height={17} width={17} />
                                                    <span className={`pl-3 ${selectedMenu == "Site Management" ? "nav-label" : "nav-label"}`}>Site Management</span>
                                                </>
                                        }
                                    </a>
                                </li>
                                {selectedMenu == "Site Management" &&
                                    <ul className={`nav-dropdown-items`} id="products">
                                        <li
                                            style={{ display: IS_SITE_MANAGEMENT_TAB_HIDDEN ? 'none' : 'block' }}
                                            className={`${selectedSubMenu == 'Site Configuration' ? 'active-sub-menu' : ''}`}
                                            onClick={() => {
                                                if (selectedMenu == 'Site Management' && selectedSubMenu == 'Site Configuration') {
                                                    return;
                                                }
                                                onNavigate('Site Configuration');
                                                setIsItemClick(false);
                                                setSelectedSubMenu('Site Configuration');
                                                setSelectedSite(tempSiteObj);
                                                setInterfaceDataList(null)
                                                history.push(CONFIGURATION);
                                            }}>
                                            <span className='sidebarLabel'>Site Configuration</span>
                                        </li>
                                        {/* <li
                                            style={{ display: IS_SITE_MANAGEMENT_TAB_HIDDEN ? 'none' : 'block' }}
                                            className={`${selectedSubMenu == 'Manage Site Groups' ? 'active-sub-menu' : ''}`} onClick={() => {
                                                onNavigate('Manage Site Groups');
                                                setIsItemClick(false);
                                                setSelectedSubMenu('Manage Site Groups');
                                                history.push(CONFIG_MANAGESITEGROUPS);
                                            }}>
                                            <span className='sidebarLabel'> Manage Site Groups</span>
                                        </li> */}
                                    </ul>
                                }

                                <li
                                    style={{ display: IS_CUSTOMER_TAB_HIDDEN ? 'none' : 'block' }}
                                    onClick={() => { setSelectedMenu('Customers'); onMoveNext('customer'); history.push(CONFIG_CUSTOMER) }}
                                    className={` ${selectedMenu == "Customers" ? "nav-item nav-dropdown open noDrop navPage" : 'nav-item nav-dropdown navPage'}`}>
                                    <a className='nav-link'>
                                        {
                                            !isDarkTheme ?
                                                <>
                                                    <img src={selectedMenu == "Customers" ? UsersWhite : UsersWhite} alt="Logo" height={17} width={17} />
                                                    <span className={`pl-3 nav-label`}>Customers</span>
                                                </>
                                                :
                                                <>
                                                    <img className='onHoverImage' src={selectedMenu == "Customers" ? UsersWhite : UsersBlue} alt="Logo" height={17} width={17} />
                                                    <img src={UsersWhite} className='onHoverActiveImage' height={17} width={17} />
                                                    <span className={`pl-3 nav-label`}>Customers</span>
                                                </>
                                        }
                                    </a>
                                </li>
                                


                                <li
                                    style={{ display: IS_SITE_MANAGEMENT_TAB_HIDDEN ? 'none' : 'block' }}
                                    onClick={() => { setSelectedMenu('Sites'); onMoveNext('sites'); setSelectedSubMenu('Sites'); history.push(CONFIG_SITE)}}
                                    className={` ${selectedMenu == "Sites" ? "nav-item nav-dropdown open" : 'nav-item nav-dropdown'}`}>
                                    <a className='nav-link'>
                                        {
                                            !isDarkTheme ?
                                            <>
                                                <img src={selectedMenu == "Sites" ? SiteTemplateLocWhite : SiteTemplateLocWhite} alt="Logo" height={17} width={17} />
                                                <span className={`pl-3 nav-label`}>Sites</span>
                                            </>
                                            :
                                            <>
                                                <img className='onHoverImage' src={selectedMenu == "Sites" ? SiteTemplateLocWhite : SiteTemplateLocBlue} alt="Logo" height={17} width={17} />
                                                <img src={SiteTemplateLocWhite} className='onHoverActiveImage' height={17} width={17} />
                                                <span className={`pl-3 nav-label`}>Sites</span>
                                            </>
                                        }
                                    </a>
                                </li>
                                {selectedMenu == "Sites" &&
                                    <ul className={`nav-dropdown-items`} id="products">
                                        {/* <li className={`${selectedSubMenu == 'Sites' ? 'active-sub-menu' : ''}`}
                                            onClick={() => {
                                                onNavigate('Sites');
                                                setIsItemClick(false);
                                                setSelectedSubMenu('Sites');
                                                history.push(CONFIG_SITE);
                                            }}>
                                            <span className='sidebarLabel'>Sites</span>
                                        </li> */}

                                        <li className={`${selectedSubMenu == 'Zones' ? 'active-sub-menu' : ''}`} 
                                            onClick={() => {
                                                onNavigate('Zones');
                                                setIsItemClick(false);
                                                setSelectedSubMenu('Zones');
                                                history.push(CONFIG_ZONE)
                                            }}>
                                            <span className='sidebarLabel'>Zones</span>
                                        </li>

                                        <li className={`${selectedSubMenu == 'Emergency Contact' ? 'active-sub-menu' : ''}`} 
                                            onClick={() => {
                                                onNavigate('Emergency Contact');
                                                setIsItemClick(false);
                                                setSelectedSubMenu('Emergency Contact');
                                                history.push(CONFIG_EMERGENCY_CONTACT)
                                            }}>
                                            <span className='sidebarLabel'>Emergency Contacts</span>
                                        </li>
                                        <li className={`${selectedSubMenu == 'Emergency Contact Mapping' ? 'active-sub-menu' : ''}`} 
                                            onClick={() => {
                                                onNavigate('Emergency Contact Mapping');
                                                setIsItemClick(false);
                                                setSelectedSubMenu('Emergency Contact Mapping');
                                                history.push(CONFIG_CONTACT_MAPPINGS)
                                            }}>
                                            <span className='sidebarLabel'>Emergency Contacts Mapping</span>
                                        </li>
                                    </ul>
                                }

                                 <li
                                    style={{ display: IS_INTERFACE_TAB_HIDDEN ? 'none' : 'block' }}
                                    onClick={() => { setSelectedMenu('Interface'); onMoveNext('Interface'); setSelectedSubMenu('Interface'); history.push(CONFIG_INTERFACE)}}
                                    className={` ${selectedMenu == "Interface" ? "nav-item nav-dropdown open" : 'nav-item nav-dropdown'}`}>
                                    <a className='nav-link'>
                                        {
                                            !isDarkTheme ?
                                                <>
                                                    <img src={selectedMenu == "Interface" ? InterfaceWhite : InterfaceWhite} alt="Logo" height={17} width={17} />
                                                    <span className={`pl-3 nav-label`}>Interface</span>
                                                </>
                                                :
                                                <>
                                                    <img className='onHoverImage' src={selectedMenu == "Interface" ? InterfaceWhite : Interface} alt="Logo" height={17} width={17} />
                                                    <img src={InterfaceWhite} className='onHoverActiveImage' height={17} width={17} />
                                                    <span className={`pl-3 nav-label`}>Interface</span>
                                                </>
                                        }
                                    </a>
                                </li>
                                {
                                    selectedMenu == "Interface" &&
                                    <ul className={`nav-dropdown-items`} id="products">
                                        
                                        {/* <li className={`${selectedSubMenu == 'Interface' ? 'active-sub-menu' : ''}`} onClick={() => {
                                            onNavigate('Interface');
                                            setIsItemClick(false);
                                            setSelectedSubMenu('Interface');
                                            history.push(CONFIG_INTERFACE)
                                        }}>
                                            <span className='sidebarLabel'>Interface</span>
                                        </li> */}
                                        <li className={`${selectedSubMenu == 'Devices' ? 'active-sub-menu' : ''}`} onClick={() => {
                                            onNavigate('Devices');
                                            setIsItemClick(false);
                                            setSelectedSubMenu('Devices');
                                            history.push(CONFIG_DEVICES)
                                        }}>
                                            <span className='sidebarLabel'> Devices</span>
                                        </li>
                                        {/* <li className={`${selectedSubMenu == 'Discover Devices' ? 'active-sub-menu' : ''}`} onClick={() => {
                                            onNavigate('Discover Devices');
                                            setIsItemClick(false);
                                            setSelectedSubMenu('Discover Devices');
                                            history.push(CONFIG_DISCOVER_DEVICES)
                                        }}>
                                            <span className='sidebarLabel'> Discover Devices</span>
                                        </li>
                                        <li className={`${selectedSubMenu == 'Recording Configuration' ? 'active-sub-menu' : ''}`} onClick={() => {
                                            onNavigate('Recording Configuration');
                                            setIsItemClick(false);
                                            setSelectedSubMenu('Recording Configuration');
                                            history.push(CONFIG_RECORDING_CONFIGURATION)
                                        }}>
                                            <span className='sidebarLabel'>Recording Configuration</span>
                                        </li> */}
                                    </ul>
                                }

                                <li
                                    style={{ display: IS_ONVIF_TAB_HIDDEN ? 'none' : 'block' }}
                                    onClick={() => { setSelectedMenu('Onvif'); onMoveNext('PreOnboardDevices'); setSelectedSubMenu('Pre Onboard Devices'); history.push(CONFIG_PREDISCOVER_DEVICES)}}
                                    className={` ${selectedMenu == "Onvif" ? "nav-item nav-dropdown open" : 'nav-item nav-dropdown'}`}>
                                    <a className='nav-link'>
                                        {
                                            !isDarkTheme ?
                                                <>
                                                    <img src={selectedMenu == "Onvif" ? OnvifWhite : OnvifWhite} alt="Logo" height={17} width={17} />
                                                    <span className={`pl-3 nav-label`}>Onvif</span>
                                                </>
                                                :
                                                <>
                                                    <img className='onHoverImage' src={selectedMenu == "Onvif" ? OnvifWhite : Onvif} alt="Logo" height={17} width={17} />
                                                    <img src={OnvifWhite} className='onHoverActiveImage' height={17} width={17} />
                                                    <span className={`pl-3 nav-label`}>Onvif</span>
                                                </>
                                        }
                                    </a>
                                </li>
                                {
                                    selectedMenu == "Onvif" &&
                                    <ul className={`nav-dropdown-items`} id="products">
                                        <li className={`${selectedSubMenu == 'Pre Onboard Devices' ? 'active-sub-menu' : ''}`} onClick={() => {
                                            onNavigate('Pre Onboard Devices');
                                            setIsItemClick(false);
                                            setSelectedSubMenu('Pre Onboard Devices');
                                            history.push(CONFIG_PREDISCOVER_DEVICES)
                                        }}>
                                            <span className='sidebarLabel'>Pre Onboard Devices</span>
                                        </li>
                                        <li className={`${selectedSubMenu == 'Discover Devices' ? 'active-sub-menu' : ''}`} onClick={() => {
                                            onNavigate('Discover Devices');
                                            setIsItemClick(false);
                                            setSelectedSubMenu('Discover Devices');
                                            history.push(CONFIG_DISCOVER_DEVICES)
                                        }}>
                                            <span className='sidebarLabel'> Discover Devices</span>
                                        </li>
                                        
                                        <li className={`${selectedSubMenu == 'View Discover Devices' ? 'active-sub-menu' : ''}`} onClick={() => {
                                            onNavigate('View Discover Devices');
                                            setIsItemClick(false);
                                            setSelectedSubMenu('View Discover Devices');
                                            history.push(CONFIG_VIEWDISCOVER_DEVICES)
                                        }}>
                                            <span className='sidebarLabel'> View Discovered Devices</span>
                                        </li>
                                        <li className={`${selectedSubMenu == 'Auto Discover Devices' ? 'active-sub-menu' : ''}`} onClick={() => {
                                            onNavigate('Auto Discover Devices');
                                            setIsItemClick(false);
                                            setSelectedSubMenu('Auto Discover Devices');
                                            history.push(CONFIG_AUTODISCOVER_DEVICES)
                                        }}>
                                            <span className='sidebarLabel'>Auto Discovery</span>
                                        </li>
                                        {/* <li 
                                        className={`${selectedSubMenu == 'Recording Configuration' ? 'active-sub-menu' : ''}`} onClick={() => {
                                            onNavigate('Recording Configuration');
                                            setIsItemClick(false);
                                            setSelectedSubMenu('Recording Configuration');
                                            history.push(CONFIG_RECORDING_CONFIGURATION)
                                        }}>
                                            <span className='sidebarLabel'>Recording Configuration</span>
                                        </li> */}
                                    </ul>
                                }


                                <li
                                    style={{ display: IS_ALERT_TEMPLATE_TAB_HIDDEN ? 'none' : 'block' }}
                                    onClick={() => {
                                        setSelectedMenu('Alert Template'); onMoveNext('alertTemplate'); setSelectedSubMenu('Add Alert Template');
                                        let tObj = {
                                            templateId: "",
                                            templateName: "",
                                            templateClientId: "0",
                                            templateSiteId: [],
                                            templateDeviceTypeId: "0",
                                            templateDeviceSubTypeId: "0",
                                            templateDevice: [],
                                            templateAlertType: "0",
                                            scheduleType: "NA",
                                            schedulerObj: {},
                                            tempSelectedSites: [],
                                            tempSelectedDevices: [],
                                        }
                                        setAlertTemplateObj(tObj);
                                        setIsAlertTemplateEdit(true)
                                        setIsAlertTempFormEnabled(true);
                                        setIsEmptyFormAlert(true);
                                        setDeviceTemplateList([]);
                                        setDevTemClicked(false);
                                        setSelTempDevice(null);
                                        setDisplayButtons(true);
                                        setActivityLogShow(false);
                                        history.push(CONFIG_ALERTTEMPLATE);
                                    }}
                                    className={` ${selectedMenu == "Alert Template" ? "nav-item nav-dropdown open" : 'nav-item nav-dropdown'}`}>
                                    <a className='nav-link'>
                                        {
                                            !isDarkTheme ?
                                                <>
                                                    <img src={selectedMenu == "Alert Template" ? alertSelected : alertSelected} alt="Logo" height={17} width={17} />
                                                    <span className={`pl-3 nav-label`}>Alert Template</span>
                                                </>
                                                :
                                                <>
                                                    <img className='onHoverImage' src={selectedMenu == "Alert Template" ? alertSelected : alertUnselected} alt="Logo" height={17} width={17} />
                                                    <img src={alertSelected} className='onHoverActiveImage' height={17} width={17} />
                                                    <span className={`pl-3 nav-label`}>Alert Template</span>
                                                </>
                                        }
                                    </a>
                                </li>
                                {
                                    selectedMenu == "Alert Template" &&
                                    <ul className={`nav-dropdown-items`} id="products">
                                        <li className={`${selectedSubMenu == 'Add Alert Template' ? 'active-sub-menu' : ''}`} onClick={() => {
                                            onNavigate('Add Alert Template');
                                            setIsItemClick(false);
                                            setSelectedSubMenu('Add Alert Template')
                                            history.push(CONFIG_ALERTTEMPLATE)
                                        }}>
                                            <span className='sidebarLabel'> Add Alert Template</span>
                                        </li>
                                        <li className={`${selectedSubMenu == 'Manage Workflow' ? 'active-sub-menu' : ''}`} onClick={() => {
                                            onNavigate('Manage Workflow');
                                            setIsItemClick(false);
                                            setSelectedSubMenu('Manage Workflow');
                                            history.push(CONFIG_WORKFLOW)
                                        }}>
                                            <span className='sidebarLabel'>Manage Workflow</span>
                                        </li>
                                    </ul>
                                }
                                <li
                                    style={{ display: IS_USERS_TAB_HIDDEN ? 'none' : 'block' }}
                                    onClick={() => { setSelectedMenu('Users'); onMoveNext('users'); setSelectedSubMenu('Add User'); history.push(CONFIG_USER)}}
                                    className={` ${selectedMenu == "Users" ? "nav-item nav-dropdown open" : 'nav-item nav-dropdown'}`}>
                                    <a className='nav-link'>
                                        {
                                            !isDarkTheme ?
                                                <>
                                                    <img src={selectedMenu == "Users" ? UsersWhite : UsersWhite} alt="Logo" height={17} width={17} />
                                                    <span className={`pl-3 nav-label`}>Users</span>
                                                </>
                                                :
                                                <>
                                                    <img className='onHoverImage' src={selectedMenu == "Users" ? UsersWhite : UsersBlue} alt="Logo" height={17} width={17} />
                                                    <img src={UsersWhite} className='onHoverActiveImage' height={17} width={17} />
                                                    <span className={`pl-3 nav-label`}>Users</span>
                                                </>
                                        }
                                    </a>
                                </li>
                                {
                                    selectedMenu == "Users" &&
                                    <ul className={`nav-dropdown-items`} id="products">
                                        
                                        <li className={`${selectedSubMenu == 'Add User' ? 'active-sub-menu' : ''}`} onClick={() => {
                                            onNavigate('Add User');
                                            setIsItemClick(false);
                                            setSelectedSubMenu('Add User');
                                            history.push(CONFIG_USER)
                                        }}>
                                            <span className='sidebarLabel'> Add User</span>
                                        </li>
                                        <li className={`${selectedSubMenu == 'User Roles' ? 'active-sub-menu' : ''}`} onClick={() => {
                                            onNavigate('User Roles');
                                            setIsItemClick(false);
                                            setSelectedSubMenu('User Roles');
                                            history.push(CONFIG_USERROLE)
                                        }}>
                                            <span className='sidebarLabel'> Roles</span>
                                        </li>
                                        {/* <li className={`${selectedSubMenu == 'FR Assignment' ? 'active-sub-menu' : ''}`} onClick={() => {
                                            onNavigate('FR Assignment');
                                            setIsItemClick(false);
                                            setSelectedSubMenu('FR Assignment');
                                            history.push(CONFIG_FR)
                                        }}>
                                            <span className='sidebarLabel'>FR Assignment</span>
                                        </li> */}
                                        {
                                            <li className={`${selectedSubMenu == 'Data Access Group' ? 'active-sub-menu' : ''}`} onClick={() => {
                                                onNavigate('Data Access Group');
                                                setIsItemClick(false);
                                                setSelectedSubMenu('Data Access Group');
                                                history.push(CONFIG_DATACCESSGROUP)
                                            }}>
                                                <span className='sidebarLabel'>  Device Access Group</span>
                                            </li>
                                        }
                                    </ul>
                                }
                                <li
                                    style={{ display: IS_NOTIFICATION_SETTING_TAB_HIDDEN ? 'none' : 'block' }}
                                    onClick={() => { setSelectedMenu('Notification Setting'); onMoveNext('notification'); history.push(CONFIG_NOTIFICATION) }}
                                    className={` ${selectedMenu == "Notification Setting" ? "nav-item nav-dropdown open noDrop navPage" : 'nav-item nav-dropdown navPage'}`}>
                                    <a className='nav-link'>
                                        {
                                            !isDarkTheme ?
                                                <>
                                                    <img src={selectedMenu == "Notification Setting" ? NotificationSelected : NotificationSelected} alt="Logo" height={17} width={17} />
                                                    <span className={`pl-3 nav-label`}>Notification Setting</span>
                                                </>
                                                :
                                                <>
                                                    <img className='onHoverImage' src={selectedMenu == "Notification Setting" ? NotificationSelected : NotificationUnSelected} alt="Logo" height={17} width={17} />
                                                    <img src={NotificationSelected} className='onHoverActiveImage' height={17} width={17} />
                                                    <span className={`pl-3 nav-label`}>Notification Setting</span>
                                                </>
                                        }
                                    </a>
                                </li>

                                {/* <li
                                    style={{ display: IS_ESCALATIONTEMPLATE_TAB_HIDDEN ? 'none' : 'block' }}
                                    onClick={() => { setSelectedMenu('Escalation Template'); onMoveNext('escalationTemplate'); history.push(CONFIG_ESCALATIONTEMPLATE) }}
                                    className={` ${selectedMenu == "Escalation Template" ? "nav-item nav-dropdown open noDrop navPage" : 'nav-item nav-dropdown navPage'}`}>
                                    <a className='nav-link'>
                                        {
                                            !isDarkTheme ?
                                                <>
                                                    <img src={selectedMenu == "Escalation Template" ? EscalationSelected : EscalationSelected} alt="Logo" height={17} />
                                                    <span className={`pl-3 nav-label`}>Escalation Template</span>
                                                </>
                                                :
                                                <>
                                                    <img className='onHoverImage' src={selectedMenu == "Escalation Template" ? EscalationSelected : EscalationUnSelected} alt="Logo" height={17} />
                                                    <img src={EscalationSelected} className='onHoverActiveImage' height={17} />
                                                    <span className={`pl-3 nav-label`}>Escalation Template</span>
                                                </>
                                        }
                                    </a>
                                </li> */}

                                <li
                                    style={{ display: IS_PREPOSTSETTING_TAB_HIDDEN ? 'none' : 'block' }}
                                    onClick={() => { setSelectedMenu('Alert Pre Post Setting'); onMoveNext('prePostSetting'); history.push(CONFIG_PREPOST) }}
                                    className={` ${selectedMenu == "Alert Pre Post Setting" ? "nav-item nav-dropdown open noDrop navPage" : 'nav-item nav-dropdown navPage'}`}>
                                    <a className='nav-link'>
                                        {
                                            !isDarkTheme ?
                                                <>
                                                    <img src={selectedMenu == "Alert Pre Post Setting" ? AlertPrePostSelected : AlertPrePostSelected} alt="Logo" height={14} />
                                                    <span className={`pl-3 nav-label`}>Alert Pre Post Setting</span>
                                                </>
                                                :
                                                <>
                                                    <img className='onHoverImage' src={selectedMenu == "Alert Pre Post Setting" ? AlertPrePostSelected : AlertPrePostDefault} alt="Logo" height={14} />
                                                    <img src={AlertPrePostSelected} className='onHoverActiveImage' height={14} />
                                                    <span className={`pl-3 nav-label`}>Alert Pre Post Setting</span>
                                                </>
                                        }
                                    </a>
                                </li>

                                <li style={{ display: "none" }}
                                    onClick={() => { setSelectedMenu('Email Setting'); onMoveNext('emailSetting'); }}
                                    className={` ${selectedMenu == "Email Setting" ? "nav-item nav-dropdown open noDrop navPage" : 'nav-item nav-dropdown navPage'}`}>
                                    <a className='nav-link'>
                                        {
                                            !isDarkTheme ?
                                                <>
                                                    <img src={selectedMenu == "Email Setting" ? NotificationSelected : NotificationSelected} alt="Logo" height={17} width={17} />
                                                    <span className={`pl-3 nav-label`}>Email Setting</span>
                                                </>
                                                :
                                                <>
                                                    <img className='onHoverImage' src={selectedMenu == "Email Setting" ? NotificationSelected : NotificationUnSelected} alt="Logo" height={17} width={17} />
                                                    <img src={NotificationSelected} className='onHoverActiveImage' height={17} width={17} />
                                                    <span className={`pl-3 nav-label`}>Email Setting</span>
                                                </>
                                        }
                                    </a>
                                </li>

                                <li
                                    style={{ display: IS_SOUNDSETTING_TAB_HIDDEN ? 'none' : 'block' }}
                                    onClick={() => { setSelectedMenu('Sound Setting'); onMoveNext('soundSetting'); history.push(CONFIG_SOUND) }}
                                    className={` ${selectedMenu == "Sound Setting" ? "nav-item nav-dropdown open noDrop navPage" : 'nav-item nav-dropdown navPage'}`}>
                                    <a className='nav-link'>
                                        {
                                            !isDarkTheme ?
                                                <>
                                                    <img src={selectedMenu == "Sound Setting" ? SoundSettingSelected : SoundSettingSelected} alt="Logo" height={17} />
                                                    <span className={`pl-3 nav-label`}>Sound Setting</span>
                                                </>
                                                :
                                                <>
                                                    <img className='onHoverImage' src={selectedMenu == "Sound Setting" ? SoundSettingSelected : SoundSettingDefault} alt="Logo" height={17} />
                                                    <img src={SoundSettingSelected} className='onHoverActiveImage' height={17} />
                                                    <span className={`pl-3 nav-label`}>Sound Setting</span>
                                                </>
                                        }
                                    </a>
                                </li>

                                <li
                                    style={{ display: IS_CENTRALIZERECORDINGSYSTEM_TAB_HIDDEN ? 'none' : 'block' }}
                                    onClick={() => { setSelectedMenu('Video Backup'); onMoveNext('centralizerecordingsystem'); history.push(CONFIG_CENTRALIZERECORDINGSYSTEM) }}
                                    className={` ${selectedMenu == "Video Backup" ? "nav-item nav-dropdown open noDrop navPage" : 'nav-item nav-dropdown navPage'}`}>
                                    <a className='nav-link'>
                                        {
                                            !isDarkTheme ?
                                                <>
                                                    <img src={selectedMenu == "Video Backup" ? CentralizeRecordingSelected : CentralizeRecordingSelected} alt="Logo" height={17} />
                                                    <span className={`pl-3 nav-label`}>Video Backup</span>
                                                </>
                                                :
                                                <>
                                                    <img className='onHoverImage' src={selectedMenu == "Video Backup" ? CentralizeRecordingSelected : CentralizeRecording} alt="Logo" height={17} />
                                                    <img src={CentralizeRecordingSelected} className='onHoverActiveImage' height={17} />
                                                    <span className={`pl-3 nav-label`}>Video Backup</span>
                                                </>
                                        }
                                    </a>
                                </li>

                                <li style={{display:"block"}}
                                    // style={{ display: IS_CENTRALIZERECORDINGSYSTEM_TAB_HIDDEN ? 'none' : 'block' }}
                                   onClick={() => { setSelectedMenu('Import'); onMoveNext('Import'); history.push(CONFIG_IMPORT) }}
                                   className={` ${selectedMenu == "Import" ? "nav-item nav-dropdown open noDrop navPage" : 'nav-item nav-dropdown navPage'}`}>
                                    <a className='nav-link'>
                                            {
                                                !isDarkTheme ?
                                                <>
                                                    <img src={selectedMenu == "Import" ? ImportSidebarIconWhite : ImportSidebarIconWhite} alt="Logo" height={17} width={17} />
                                                    <span className={`pl-3 ${selectedMenu == "Import" ? "nav-label" : "nav-label"}`}>Import</span>
                                                </>
                                                :
                                                <>
                                                    <img className='onHoverImage' src={selectedMenu == "Import" ? ImportSidebarIconWhite : ImportSidebarIcon} alt="Logo" height={17} width={17} />
                                                    <img src={ImportSidebarIconWhite} className='onHoverActiveImage' height={17} width={17} />
                                                    <span className={`pl-3 ${selectedMenu == "Import" ? "nav-label" : "nav-label"}`}>Import</span>
                                                </>
                                            }
                                        </a>
                                </li>

                                <li style={{display:"none"}}
                                    // style={{ display: IS_CENTRALIZERECORDINGSYSTEM_TAB_HIDDEN ? 'none' : 'block' }}
                                   onClick={() => { setSelectedMenu('Export'); onMoveNext('Export'); history.push(CONFIG_EXPORT) }}
                                   className={` ${selectedMenu == "Export" ? "nav-item nav-dropdown open noDrop navPage" : 'nav-item nav-dropdown navPage'}`}>
                                    <a className='nav-link'>
                                            {
                                                !isDarkTheme ?
                                                <>
                                                    <img src={selectedMenu == "Export" ? CentralizeRecordingSelected : CentralizeRecordingSelected} alt="Logo" height={17} width={17} />
                                                    <span className={`pl-3 ${selectedMenu == "Export" ? "nav-label" : "nav-label"}`}>Export</span>
                                                </>
                                                :
                                                <>
                                                    <img className='onHoverImage' src={selectedMenu == "Export" ? CentralizeRecordingSelected : CentralizeRecording} alt="Logo" height={17} width={17} />
                                                    <img src={CentralizeRecordingSelected} className='onHoverActiveImage' height={17} width={17} />
                                                    <span className={`pl-3 ${selectedMenu == "Export" ? "nav-label" : "nav-label"}`}>Export</span>
                                                </>
                                            }
                                        </a>
                                </li>

                                <li
                                    onClick={() => { setSelectedMenu('Report Template'); onMoveNext('ReportTemplate'); history.push(CONFIG_REPORT)}}
                                    className={` ${selectedMenu == "Report Template" ? "nav-item nav-dropdown open noDrop navPage" : 'nav-item nav-dropdown navPage'}`}>
                                    <a className='nav-link'>
                                        {
                                            !isDarkTheme ?
                                                <>
                                                    <img src={selectedMenu == "Report Template" ? reportSelected : reportSelected} alt="Logo" height={17} width={17} />
                                                    <span className={`pl-3 nav-label`}>Report Template</span>
                                                </>
                                                :
                                                <>
                                                    <img className='onHoverImage' src={selectedMenu == "Report Template" ? reportSelected : reportUnselected} alt="Logo" height={17} width={17} />
                                                    <img src={reportSelected} className='onHoverActiveImage' height={17} width={17} />
                                                    <span className={`pl-3 nav-label`}>Report Template</span>
                                                </>
                                        }
                                    </a>
                                </li>

                                <li style={{display:"block"}}
                                    onClick={() => { setSelectedMenu('Dashboard Setting'); onMoveNext('DashboardSetting'); history.push(CONFIG_DASHBOARDSETTING)}}
                                    className={` ${selectedMenu == "Dashboard Setting" ? "nav-item nav-dropdown open noDrop navPage" : 'nav-item nav-dropdown navPage'}`}>
                                    <a className='nav-link'>
                                        {
                                            !isDarkTheme ?
                                                <>
                                                    <img src={selectedMenu == "Dashboard Setting" ? dashboard : dashboard} alt="Logo" height={17} width={17} />
                                                    <span className={`pl-3 nav-label`}>Dashboard Settings</span>
                                                </>
                                                :
                                                <>
                                                    <img className='onHoverImage' src={selectedMenu == "Dashboard Setting" ? dashboard : DashboardUnselected} alt="Logo" height={17} width={17} />
                                                    <img src={dashboard} className='onHoverActiveImage' height={17} width={17} />
                                                    <span className={`pl-3 nav-label`}>Dashboard Settings</span>
                                                </>
                                        }
                                    </a>
                                </li>


                                {
                                    selectedMenu == "Review" &&
                                    <ul className={`nav-dropdown-items`} id="products">
                                        <li className={`${selectedSubMenu == 'Site Template' ? 'active-sub-menu' : ''}`} onClick={() => {
                                            onNavigate('Site Template');
                                            setIsItemClick(false);
                                            setSelectedSubMenu('Site Template');
                                        }}>
                                            <span className='sidebarLabel'> Site Template</span>
                                        </li>
                                        <li className={`${selectedSubMenu == 'Devices' ? 'active-sub-menu' : ''}`} onClick={() => {
                                            onNavigate('Devices');
                                            setIsItemClick(false);
                                            setSelectedSubMenu('Devices');
                                        }}>
                                            <span className='sidebarLabel'> Devices</span>
                                        </li>
                                        <li className={`${selectedSubMenu == 'Alert Template' ? 'active-sub-menu' : ''}`} onClick={() => {
                                            onNavigate('Alert Template');
                                            setIsItemClick(false);
                                            setSelectedSubMenu('Alert Template');
                                        }}>
                                            <span className='sidebarLabel'> Alert Template</span>
                                        </li>
                                        <li className={`${selectedSubMenu == 'Users' ? 'active-sub-menu' : ''}`} onClick={() => {
                                            onNavigate('Users');
                                            setIsItemClick(false);
                                            setSelectedSubMenu('Users');
                                        }}>
                                            <span className='sidebarLabel'> Users</span>
                                        </li>
                                    </ul>
                                }
                            </ul>
                        </div>
                        <div className='versionTextDiv'>
                        <button className='termsText' onClick={(e) => { history.push(ABOUTTERMS) }}>T&C</button>
                            <label className='versionLabel'>Version: {VERSION}</label>
                        </div>
                    </nav>
                </div>
            </div>
        </div>
    )
}